import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTransform'
})
export class DateTransformPipe implements PipeTransform {
  transform(value: string | Date, format: string = 'dd/MM/yyyy HH:mm:ss', dateFlag: boolean = false): string {

    try {
      if (!value) return '';

      const dateFormatter = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Perth',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });

      if (dateFlag) {

        let utcDate: Date;
        if (typeof value === 'string' && String(format).toLocaleLowerCase().includes('dd/mm/yyyy')) {
          const [day, month, year] = value.split('/').map(Number);
          utcDate = new Date(year, month - 1, day);
        } else {
          utcDate = new Date(value);
        }

        const formattedDateParts = dateFormatter.formatToParts(utcDate);
        const day = formattedDateParts.find(p => p.type === 'day')?.value;
        const month = formattedDateParts.find(p => p.type === 'month')?.value;
        const year = formattedDateParts.find(p => p.type === 'year')?.value;

        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
      }

      let iso = typeof value === 'string' && !value.includes('Z') ? value : value;

      const utcDate = new Date(iso);

      const timeFormatter = new Intl.DateTimeFormat('en-AU', {
        timeZone: 'Australia/Perth',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      });

      const formattedDate = dateFormatter.format(utcDate);
      const formattedTime = timeFormatter.format(utcDate);
      
      return `${formattedDate} ${formattedTime}`;
    } catch (error) {
      console.error('Date transformation error:', error);
      return '';
    }
  }
}
